import React from "react";
import Typography from '@material-ui/core/Typography';
import { Auth, I18n } from 'aws-amplify';
import { Link } from 'react-router-dom';
import {TERM_VER} from "../../configures/val.js";
import checkTermsVer from '../util/checkTermsVer.js';
import LapDialog from '../util/laplaceDialog.js';

export default class UserProfileView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      isError: true,
      termVerError: false
    };
  }
  showOrganization = (userProf) => {
    if (!userProf.hasOwnProperty("custom:organization"))
      return (<div />);
    if (userProf["custom:organization"] === '')
      return (<div />);
    return(
      <div>
        <dt class="mypageUserinfoItemHeader">
          <Typography variant="subheading" gutterBottom>
            {I18n.get('Company/Institution name')}
          </Typography>
        </dt>
        <dd class="mypageUserinfoItemData">
          <Typography>{userProf["custom:organization"]}</Typography>
        </dd>
      </div>
    );
  }
  checkUser() {
    const that = this;
    return Auth.currentAuthenticatedUser().then(user => {
      if (!that._isMounted) { return; }
      Auth.userAttributes(user).then((attrRet) => {
        const isLowVer = checkTermsVer(attrRet, 'custom:agreed_term', TERM_VER, 'ver');
        if (isLowVer) {
          this.setState({
            termVerError: true,
          });
          return;
        }
        this.props.updateHeader('userProf');
        // ログイン済みで正しくトークンが生きている
        return;
      }).catch((attrErr) => {
        // トークンが死んでいる可能性がある
        Auth.signOut().then(() => this.props.authStateChange('signIn'));
      });
    }).catch(err => {
      if (!that._isMounted) { return; }
      Auth.signOut().then(() => this.props.authStateChange('signIn'));
    });
  }
  componentDidMount() {
    this._isMounted = true;
    this.checkUser();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  async closeTermVerError (that) {
    const user = await Auth.currentAuthenticatedUser();
    that.props.authStateChange('reagreeTermsDocs', user);
    this.setState({
      termVerError: false
    });
    return;
  }

  render() {
    const {userProf} = this.props;
    if (userProf) {
      return (
        <div className="mypageContainer">
          <p className="mypageTitle"><span class="mypageTitleIcon"></span>{I18n.get('Sign In Account')}</p>
          <dl className="mypageUserinfoItem">
            <dt class="mypageUserinfoItemHeader itemBorder">
              <Typography variant="subheading" gutterBottom>
                {I18n.get('Mail')}
              </Typography>
            </dt>
            <dd class="mypageUserinfoItemData itemBorder">
              {userProf.email}<Link className="mypageNormalButton blue" to="/updateaddress">{I18n.get('Edit')}</Link>
            </dd>
            <dt class="mypageUserinfoItemHeader itemBorder">
              <Typography variant="subheading" gutterBottom>
                {I18n.get('Password')}
              </Typography>
            </dt>
            <dd class="mypageUserinfoItemData itemBorder">
              ●●●●●●●●<Link className="mypageNormalButton blue" to="/updatepass">{I18n.get('Edit')}</Link>
            </dd>
          </dl>
          <p className="mypageTitle"><span class="mypageTitleIcon"></span>
            {I18n.get('Personal data')}<Link className="mypageNormalButton blue" to="/updateprofile">{I18n.get('Edit')}</Link>
          </p>
          <dl className="mypageUserinfoItem">
            <dt class="mypageUserinfoItemHeader">
              <Typography variant="subheading" gutterBottom>
                {I18n.get('Name')}
              </Typography>
            </dt>
            <dd class="mypageUserinfoItemData">
              <Typography>{userProf.family_name}{userProf.given_name}</Typography>
            </dd>
            {this.showOrganization(userProf)}
          </dl>
          <LapDialog
            title={''}
            contentElem={
              <div>
                <p>{I18n.get('Terms of Service is updated.')}</p>
                <p>{I18n.get('Please reconfirm it.')}</p>
              </div>
            }
            firstButtonText={'OK'}
            firstButtonFunc={() => this.closeTermVerError(this)}
            open={this.state.termVerError}
            toClose={() => {return;}}
          />
        </div>
      );
    } else {
      return (
        <div>
          <Typography className = 'textCenter'variant="subheading" gutterBottom>
            {I18n.get('Please logout, and re-login')}
          </Typography>
        </div>
      );
    }
  }
}
